import { Paper } from '@material-ui/core'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import Swal from 'sweetalert2'
import server from 'util/Server';
import ContainerHeader from 'components/ContainerHeader/index'
import LoaderComponent from 'components/LoaderTerpel/LoaderTerpel'
import { REPORTE_RECAUDO_VENTAS } from 'constants/columnas/columnasReportes'
import { formatearFecha, formatosFecha } from 'util/formatDate'
import Storage from 'util/store/Storage'
import { getSelectEDS } from '../servicios/serviciosSelect'
import SmartDataTable from 'components/SmartDataTable/SmartDataTable'
import { getRegionalService } from 'services/selectServices/services';
import FiltrosFC from 'components/FiltrosFC/FiltrosFC';
import { App } from 'antd';
import { getClientes, getClientServicesGnv, getTotalizadoVentasGnv } from '../servicios/consultaReporte';
import TotalizadorVentasGnvDetalle from './components/TotalizadorVentasGnvDetalle';
import { parseToSelectOption } from 'util/funcionesNews';
import WebThermalPrinterColletions from './components/WebThermalPrinterColletions';
import { getTirillaLogo } from '../cierreDatagas/components/webThermalPrinter.service';

const TIPO_REPORTE = [
  {
    label: 'Clientes recaudo', value: 'G'
  },
  {
    label: 'Clientes credito', value: 'C'
  },
  {
    label: 'Todos', value: 'T'
  }
]

const INITIAL_VALUES_TOTALES = {
  valor_venta_total: 0,
  cantidad: 0,
  valor_venta_bruta: 0,
  valor_venta_recaudo: 0,
}
const ReporteRecaudoVentas = (props: PropsComponent) => {
  const { notification } = App.useApp()
  const { empresasHijos, usuario, negocio } = Storage.getState()
  const filtroRef: any = useRef(null)
  const PREFIX_URL = `${server.host}${server.puerto_reporte_service}/api/recaudos`
  // const PREFIX_URL = `https://q6h7vxbz-7013.use2.devtunnels.ms/api/recaudos`
  const URL_REPORTE_RECAUDOS = PREFIX_URL
  const URL_DOC_REPORTE = `${PREFIX_URL}/documento-reporte`
  const [loaderNew, setLoaderNew] = useState(false)
  const [loader, setLoader] = useState(false)
  const [totalizadores, setTotalizadores] = useState<{
    valor_venta_total: number,
    cantidad: number,
    valor_venta_recaudo: number,
    valor_venta_bruta: number
  }>(INITIAL_VALUES_TOTALES)
  const [loadingTotal, setLoadingTotal] = useState(false)
  const [update, setUpdate] = useState<boolean | null>(null)
  const [nombreReporte, setNombreReporte] = useState('Reporte_ventas_gnv_')
  const [filtrosTabla, setFiltrosTabla] = useState({} as any)
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [logoTicket, setLogoTicket] = useState<string>('')
  const [filtros, setFiltros] = useState({
    selectedDate: null,
    selectedDateFin: null,
    estacionesbd: [],
    clientesbd: [] as any[],
    empresaSeleccionada: usuario.tipo == 5 ? usuario.empresas_id : null,
    clienteSeleccionado: null,
    opcionSeleccionada: 'T'
  })

  const handleLoading = (value: boolean) => {
    setLoaderNew(value)
  }

  const handleSetFiltros = (name: string) => (valor: any): void => {
    setFiltros((prev) => ({ ...prev, [name]: valor }))
  }

  const obtenerDatos = useCallback(async (): Promise<void> => {
    const estacionesbd = await getSelectEDS(empresasHijos)
    setFiltros(prevF => ({ ...prevF, estacionesbd }))
  }, [empresasHijos])


  const getTotalizadores = async (body: any) => {
    try {
      setLoadingTotal(true)
      const { data }: any = await getTotalizadoVentasGnv(body)
      const { total_ventas, total_cantidad, total_ventas_bruta, total_recaudado } = data.data
      setTotalizadores({
        valor_venta_total: total_ventas,
        cantidad: total_cantidad,
        valor_venta_bruta: total_ventas_bruta,
        valor_venta_recaudo: total_recaudado
      })
    } catch (error) {
      setTotalizadores(INITIAL_VALUES_TOTALES)
    } finally {
      setLoadingTotal(false)
    }
  }
  const nullUpdate = () => {
    setUpdate(null)
  }
  const fetchLogo = async () => {
    const response = await getTirillaLogo(filtros.empresaSeleccionada);
    setLogoTicket(response || '');
  };

  const buscarDatosFiltrado = async () => {
    try {
      const { empresaSeleccionada, selectedDate, selectedDateFin, clienteSeleccionado, opcionSeleccionada } = filtros
      if (!selectedDate || !selectedDateFin) return notification.info({
        message: 'Atención',
        description: 'Debe seleccionar un rango de fechas',
        placement: 'top'
      })

      if (!empresaSeleccionada) return notification.info({
        message: 'Atención',
        description: `Debe seleccionar una estación`,
        placement: 'top'
      })

      setLoadingTotal(true)
      setLoader(true)
      const datos = {
        fecha_final: formatearFecha(selectedDateFin, formatosFecha.fechaServidor),
        fecha_inicial: formatearFecha(selectedDate, formatosFecha.fechaServidor),
        empresa_id: empresaSeleccionada,
        identificadorEstacion: empresaSeleccionada,
        cliente: opcionSeleccionada === 'T' ? undefined : clienteSeleccionado,
        tipo_reporte: opcionSeleccionada
      }
      setFiltrosTabla(datos)
      getTotalizadores(datos)
      fetchLogo()
      setUpdate(true)
      setSelectedRowKeys([])
    } catch (error) {
      console.log(error)
      Swal.fire('Ups', 'Ocurrió un error al consultar el reporte, por favor intente más tarde', 'error')
    } finally {
      setLoadingTotal(false)
      setLoader(false)
    }
  }

  const handleRowClick = (record: any, index: any) => {
    const selectedKey = record.id_movimiento; // Asegúrate de que tengas una clave única para cada fila
    const isSelected = selectedRowKeys.includes(selectedKey);

    if (isSelected) {
      // Si ya está seleccionado, deselecciónalo
      const updatedKeys = selectedRowKeys.filter((key: any) => key !== selectedKey);
      setSelectedRowKeys(updatedKeys);
    } else {
      // Si no está seleccionado, agrégalo a la selección
      setSelectedRowKeys([...selectedRowKeys, selectedKey]);
    }
  };

  const onSelectChangeRow = (selectedKeys: any) => {
    setSelectedRowKeys(selectedKeys);
  };

  const getClientesByEDS = async (empresas: string) => {
    let clientes: any[] = [];

    // Lógica condicional según el tipo de reporte seleccionado
    if (filtros.opcionSeleccionada === 'G') {
      const { data } = await getClientServicesGnv({ destinationId: 3, empresaId: empresas, organizacionId: usuario.organizacion_id });
      clientes = parseToSelectOption(data.data, 'label', 'id_cliente')
    } else if (filtros.opcionSeleccionada === 'C') {
      clientes = await getClientes(empresas);
    } else {
      clientes = [];
    }

    setFiltros((prev) => ({ ...prev, clientesbd: clientes }));
  };


  const RenderDataTable2 = () => {
    return (
      <>
        <Paper className="mx-auto" style={{ padding: '5px' }}>
          <SmartDataTable
            handleIdRecord={handleRowClick}
            keyId="id_movimiento"
            idRecord={selectedRowKeys}
            onSelectChangeRow={onSelectChangeRow}
            rowSelectionOn
            exportPDFLocal={true}
            columns={REPORTE_RECAUDO_VENTAS}
            hanldeLoading={handleLoading}
            apiUrl={URL_REPORTE_RECAUDOS}
            filterTabla={filtrosTabla}
            nullUpdate={nullUpdate}
            update={update}
            nombre_reporte={nombreReporte}
            tituloReporte={nombreReporte.replaceAll('_', ' ')}
            genExcelUrl={`${URL_DOC_REPORTE}?tipo=EXCEL`}
            genPdfUrl={`${URL_DOC_REPORTE}?tipo=PDF`}
            header={() => <TotalizadorVentasGnvDetalle loading={loadingTotal} totalizadores={totalizadores} />}
          />
        </Paper>
      </>
    )
  }
  /**
   * @Description: Funcion que consume un endpoint
   * @input {String}
          * @return {String}
          * @
          */


  /*   useEffect(() => {
      if (usuario.tipo != 5) {

        setFiltros(prevF => ({ ...prevF, empresaSeleccionada: null }))
        filtroRef?.current?.resetSelectB()
        setFiltrosTabla({})

        obtenerDatos()

      }

    }, [obtenerDatos]) */

  useEffect(() => {
    if (usuario.tipo == 5) {
      getClientesByEDS(usuario.empresas_id)

    } else {
      obtenerDatos()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {


    filtroRef?.current?.resetSelectC();
    if (!filtros.empresaSeleccionada) {
      setFiltros({ ...filtros, clientesbd: [], clienteSeleccionado: null })
      return
    }
    if (usuario.tipo === 5) {
      getClientesByEDS(usuario.empresas_id)
    } else if (usuario.tipo === 3 && (filtros.empresaSeleccionada != null)) {
      getClientesByEDS(filtros.empresaSeleccionada)
    }

  }, [filtros.empresaSeleccionada, filtros.opcionSeleccionada])

  return (
    <div className="dashboard animated slideInUpTiny animation-duration-3">
      <ContainerHeader match={props.match} title={'REPORTE VENTAS RECAUDO Y CREDITO'} />
      <FiltrosFC
        ref={filtroRef}
        loadingButton={(loaderNew || loadingTotal)}
        rangePicker
        selectA={usuario.tipo === 3}
        selectB
        selectC
        formatDateRange='YYYY-MM-DD'
        onChangeSelectA={handleSetFiltros('empresaSeleccionada')}
        onChangeSelectB={handleSetFiltros('opcionSeleccionada')}
        onChangeSelectC={handleSetFiltros('clienteSeleccionado')}
        optionsSelectA={filtros.estacionesbd}
        optionsSelectB={TIPO_REPORTE}
        optionsSelectC={filtros.clientesbd}
        placeholderSelectA={'Estaciones'}
        placeholderSelectB={'Tipo reporte'}
        placeholderSelectC={'Clientes'}
        disabledSelectC={filtros.opcionSeleccionada == 'T'}
        defaultValueB={TIPO_REPORTE[2]}
        onChangeRangePicker={(e) => {
          handleSetFiltros('selectedDate')(e[0])
          handleSetFiltros('selectedDateFin')(e[1])
        }}
        onClickButton={buscarDatosFiltrado}
        textButton='Buscar'
      />
      <WebThermalPrinterColletions
        tickets_ids={selectedRowKeys}
        logoTicket={logoTicket}
      />

      {loader ? (
        <LoaderComponent />
      ) :
        RenderDataTable2()
      }
    </div>
  )
}

export default ReporteRecaudoVentas
